<template>
    <v-card>
        <v-card-title>
        <v-col cols="12">
            {{ titulo }}
        </v-col>
        <v-text-field
            class="px-3"
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
        />
        </v-card-title>
            <template>
                <v-data-table :headers="header" :items="items" :search="search" item-key="value">
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="(item, index) in items" :key="item.value">
                            <td>
                                <v-checkbox v-model="selectedItems" @change="desabilitaCheckbox" :disabled="index !== 0 && desabilita" :value="item.text"></v-checkbox>
                            </td>
                            <td v-if="useValue">{{ item.value }}</td>
                            <td>{{ item.text }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </template>
    </v-card>
</template>
<script>
export default {
  props: {
    titulo: { type: String, default: 'Garantias' },
    useValue: { type: Boolean, default: false },
    header: [],
    items: [],
    codigoProposta: null
  },
  data () {
    return {
      model: {},
      search: '',
      selectedItems: [],
      desabilita: false
    }
  },
  methods: {
    load () {
      const th = this;
      const parameters = [{ name: 'CodigoProposta', value: th.codigoProposta }]

      th.$api.Multiplo.Post('ListPropostaCampoAuxiliar', { parameters }).then(response => {
        if (th.$api.UI.PostLoadData(response, true)) {
          if (response.Data && response.Data.length > 0) {
            const titulo = th.titulo === 'Subcredenciadoras' ? 'SubCred' : th.titulo.substr(0, th.titulo.length - 1)
            response.Data.forEach((item) => {
              if (item.NomeCampo === 'PropostaGarantia_' + titulo) {
                th.$set(th, 'selectedItems', item.ValorCampo.split(', '))
              }
            })
          }
        }
      })
    },
    desabilitaCheckbox () {
      if (this.selectedItems.includes('Todos')) {
        this.selectedItems = ['Todos']
        this.desabilita = true
      } else {
        this.desabilita = false
      }
    },
    submit (callback) {
      const th = this
      if (th.selectedItems.length === 0) {
        th.$api.UI.ShowError('Precisa ser informado ao menos um(a) ' + th.titulo.substr(0, th.titulo.length - 1))
      } else {
        th.model.CodigoProposta = th.codigoProposta;
        th.model.Subcredenciadoras = th.selectedItems.join(', ');
        th.model.SubcredenciadorasConcat = th.titulo === 'Subcredenciadoras' ? 'SubCred' : th.titulo.substr(0, th.titulo.length - 1)
        th.$api.Sarfaty.SavePropostaCampoAuxiliar(th, callback)
      }
    }
  },
}
</script>
